<template>
  <div class="create-team">
    <div class="btn-wrapper mb-10 move-right">
      <router-link
        to="/admin/hrm/leave/settings/leave-approval"
        class="btn-back"
      >
        <span>Back</span>
      </router-link>
    </div>
    <el-form
      :model="editLeaveApproval"
      :rules="rules"
      ref="editLeaveApproval"
      class="white-bg form"
      label-position="left"
      label-width="200px"
      v-loading="loading"
    >
      <h3 class="text-gray bold mt-0 mb-40">Edit Leave Approver</h3>
      <h3>Approval List</h3>
      <div class="mt-20 ">
        <el-form-item
          label="Approval List Name"
          prop="description"
          class="mt-20"
        >
          <el-input
            placeholder="Type name of list e.g Accounts Staff"
            name="leave approval"
            type="text"
            v-model="editLeaveApproval.description"
          ></el-input>
        </el-form-item>
      </div>
      <el-form-item label="Approval Based on" prop="category_type">
        <el-radio-group v-model="editLeaveApproval.category_type" class="mt-20">
          <el-radio label="employees">Employee</el-radio>
          <el-radio label="station_grade">Grades</el-radio>
          <el-radio label="department">Department</el-radio>
          <el-radio label="branch">Branch</el-radio>
        </el-radio-group>
      </el-form-item>
      <div
        class="mt-20 "
        v-if="
          editLeaveApproval.category_type !== 'employees' &&
            editLeaveApproval.category_type !== 'branch'
        "
        prop="branch_id"
      >
        <el-form-item prop="branch_id" label="Select Branch">
          <el-select
            v-model="editLeaveApproval.branch_id"
            placeholder="Select"
            name=""
          >
            <el-option
              v-for="branch in branches"
              :key="branch.id"
              :label="branch.station_name"
              :value="branch.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="mt-20 " v-show="editLeaveApproval.category_type === 'branch'">
        <el-form-item prop="branches" label="Select Branch">
          <el-select
            v-model="editLeaveApproval.branches"
            placeholder="Select"
            name="branch"
            multiple
          >
            <el-option
              v-for="branch in branches"
              :key="branch.id"
              :label="branch.station_name"
              :value="branch.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div
        class="mt-20 "
        v-show="editLeaveApproval.category_type === 'department'"
      >
        <el-form-item
          prop="departments"
          class="mt-20"
          label="Select Department"
        >
          <el-select
            v-model="editLeaveApproval.departments"
            placeholder="Select"
            multiple
          >
            <el-option
              v-for="department in departments"
              :key="department.id"
              :label="department.department_name"
              :value="department.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div
        class="mt-20 "
        v-show="editLeaveApproval.category_type === 'employees'"
      >
        <el-form-item prop="employees" label="Select Employee">
          <el-select
            v-model="editLeaveApproval.employees"
            placeholder="Select"
            filterable
            remote
            :remote-method="searchEmployees"
            multiple
          >
            <el-option
              v-for="employee in employees"
              :key="employee.id"
              :label="employee.name"
              :value="employee.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div
        class="mt-20 "
        v-show="editLeaveApproval.category_type === 'station_grade'"
      >
        <el-form-item class="mt-20" prop="grades" label="Select Grade">
          <el-select
            v-model="editLeaveApproval.grades"
            placeholder="Select"
            multiple
          >
            <el-option
              v-for="grade in employeeGrades"
              :key="grade.id"
              :label="grade.grade_name"
              :value="grade.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <h3>Approval Details</h3>
      <el-form-item label="No of Approvals" prop="no_approvals">
        <el-input-number
          placeholder=""
          name=""
          v-model.number="no_approvals"
          :min="1"
        >
        </el-input-number>
      </el-form-item>

      <div
        class="mt-20"
        v-for="(item, i) in editLeaveApproval.approver_details"
        :key="i"
      >
        <el-form-item
          :prop="'approver_details.' + i + '.approval_person_id'"
          :label="'Approver Name ' + (i + 1)"
          :rules="{
            required: true,
            message: 'Please select approval person',
            trigger: 'blur',
          }"
        >
          <el-select
            v-model="
              editLeaveApproval.approver_details[i]['approval_person_id']
            "
            placeholder="Select Approver"
            filterable
            remote
            :remote-method="searchEmployees"
          >
            <el-option
              v-for="employee in employees"
              :key="employee.id"
              :label="employee.name"
              :value="employee.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :prop="'approver_details.' + i + '.alt_approval_person_id'"
          :label="'Alt Approver Name ' + (i + 1)"
        >
          <el-select
            v-model="
              editLeaveApproval.approver_details[i]['alt_approval_person_id']
            "
            placeholder=" Select Alt Approver"
            filterable
            remote
            :remote-method="searchEmployees"
          >
            <el-option
              v-for="employee in employees"
              :key="employee.id"
              :label="employee.name"
              :value="employee.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>

      <el-form-item label="Approval Type" prop="approval_types">
        <el-radio-group
          v-model="editLeaveApproval.approval_types"
          class="mt-20"
        >
          <el-radio label="Concurrent">Concurrent</el-radio>
          <el-radio label="Sequential">Sequential</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="">
        <div class="btn-wrapper mt-20 sec-span">
          <el-button
            class="btn btn-blue no-border btn-full-radius inline-flex flex-v-end mr-15"
            @click.prevent="update()"
            :loading="loading"
            >Save Changes</el-button
          >
          <button
            class="btn btn-light-gray no-border btn-full-radius inline-flex flex-v-end mr-15"
            @click.prevent="$router.go(-1)"
          >
            Cancel
          </button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import debounce from "lodash.debounce";

const { mapState, mapActions } = createNamespacedHelpers("admin/hrm/leave");

export default {
  data() {
    const customValidation = (rule, value, callback) => {
      const categoryTypeMap = {
        employees: this.editLeaveApproval.employees,
        department: this.editLeaveApproval.departments
          ? [this.editLeaveApproval.departments]
          : [],
        station_grade: this.editLeaveApproval.grades,
        branch: this.editLeaveApproval.branches,
      };

      if (!categoryTypeMap[this.editLeaveApproval.category_type].length > 0) {
        return callback(new Error(`Please select ${rule.field}`));
      } else {
        return callback();
      }
    };
    return {
      employees: [],
      loading: false,
      no_approvals: null,
      reset_approver_details: [],
      editLeaveApproval: {
        description: "",
        branch_id: null,
        approval_types: "",
        category_type: "employees",
        approver_details: [],
        departments: [],
        grades: [],
        employees: [],
        branches: [],
      },
      rules: {
        description: [
          {
            required: true,
            message: "Please input leave Approval list",
            trigger: "blur",
          },
        ],
        approval_types: [
          {
            required: true,
            message: "Please select approval type",
            trigger: "blur",
          },
        ],
        no_approvals: [
          {
            required: true,
            message: "Please input number of approver required",
            trigger: "blur",
          },
        ],
        branch_id: [
          { required: true, message: "Please select branch", trigger: "blur" },
        ],
        category_type: [
          {
            required: true,
            message: "Please select category type",
            trigger: "blur",
          },
        ],
        departments: [
          {
            required: true,
            message: "Please select department ",
            validator: customValidation,
          },
        ],
        grades: [
          {
            required: true,
            message: "Please select grade ",
            validator: customValidation,
          },
        ],
        employees: [
          {
            required: true,
            message: "Please select employee ",
            validator: customValidation,
          },
        ],
        branches: [
          {
            required: true,
            message: "Please select branch ",
            validator: customValidation,
          },
        ],
      },
    };
  },
  watch: {
    no_approvals: function(newValue, oldValue) {
      if (newValue === this.editLeaveApproval.approver_details.length) {
        return;
      }
      this.editLeaveApproval.no_approvals = this.no_approvals;
      if (newValue === oldValue + 1) {
        this.editLeaveApproval.approver_details.push({
          approval_person_id: null,
          alt_approval_person_id: null,
        });
        return;
      }

      this.editLeaveApproval.approver_details = this.editLeaveApproval.approver_details.slice(
        0,
        newValue
      );
    },
  },
  mounted() {
    this.getBranches();
    this.getEmployeeGrades();
    this.getDepartments();
    const id = this.$route.params.id;
    if (id) {
      this.findLeaveApproverById(id);
    }
  },
  computed: {
    ...mapState({
      branches: "branches",
      departments: "departments",
      employeeGrades: "employeeGrades",
    }),
  },
  methods: {
    ...mapActions([
      "getBranches",
      "updateLeaveApproval",
      "getEmployeeGrades",
      "getDepartments",
      "getLeaveApproverById",
    ]),
    findLeaveApproverById(id) {
      this.loading = true;
      this.$store
        .dispatch("admin/hrm/leave/getLeaveApproverById", id)
        .then(response => {
          this.loading = false;
          const {
            id,
            branch,
            approvalLevels,
            approval_types,
            category_type,
            departments,
            description,
            employeeGrades,
            employees,
            no_approvals,
            branches,
          } = response.data;

          this.editLeaveApproval.category_type =
            (employees.length > 0 && "employees") ||
            (departments.length > 0 && "department") ||
            (employeeGrades.length > 0 && "grade") ||
            (branches.length > 0 && "branch");

          const gradeIds = employeeGrades.map(x => x.id);
          const departmentIds = departments.map(x => x.id);
          const employeeIds = employees.map(x => x.id);
          const branchIds = branches.map(x => x.id);
          this.employees = employees.map(x => ({
            ...x,
            name: x.employee_name,
          }));

          const formattedApprovalLevels = approvalLevels.map(x => ({
            ...x,
            id: x.approval_person_id,
            alt_id: x.alt_approval_person_id,
            alt_approval_person_id: x.alt_approval_person,
            approval_person_id: x.approval_person_name,
          }));
          this.no_approvals = formattedApprovalLevels.length;

          this.editLeaveApproval = {
            id,
            branch_id: branch.id,
            approver_details: formattedApprovalLevels,
            approval_types,
            category_type,
            departments: departmentIds,
            description,
            grades: gradeIds,
            branches: branchIds,
            employees: employeeIds,
            no_approvals,
          };
        })
        .catch(error => {
          this.loading = false;
          this.$notification.error(error.message);
        });
    },
    update() {
      this.$refs[`editLeaveApproval`].validate(() => {
        this.reset_approver_details = this.editLeaveApproval.approver_details;
        this.editLeaveApproval.approver_details = this.editLeaveApproval.approver_details.map(
          x => {
            return {
              approver_person_id:
                typeof x.approval_person_id === "string"
                  ? x.id
                  : x.approval_person_id,
              alt_approver_person_id:
                typeof x.alt_approval_person_id === "string"
                  ? x.alt_id
                  : x.alt_approval_person_id,
            };
          }
        );
        this.loading = true;
        const inputData = {
          description: this.editLeaveApproval.description,
          approval_types: this.editLeaveApproval.approval_types,
          ...(this.editLeaveApproval.category_type === "department" && {
            category_type: this.editLeaveApproval.category_type,
            departments: this.editLeaveApproval.departments,
          }),
          ...(this.editLeaveApproval.category_type === "station_grade" && {
            category_type: this.editLeaveApproval.category_type,
            grades: this.editLeaveApproval.grades,
          }),
          ...(this.editLeaveApproval.category_type === "employees" && {
            category_type: this.editLeaveApproval.category_type,
            employees: this.editLeaveApproval.employees,
          }),
          ...(this.editLeaveApproval.category_type === "branch" && {
            category_type: this.editLeaveApproval.category_type,
            branches: this.editLeaveApproval.branches,
          }),
          branch_id: this.editLeaveApproval.branch_id,
          approver_details: this.editLeaveApproval.approver_details,
          no_approvals: this.editLeaveApproval.no_approvals,
        };
        const id = this.$route.params.id;
        if (id) {
          this.$store
            .dispatch("admin/hrm/leave/updateLeaveApprover", {
              data: inputData,
              id,
            })
            .then(() => {
              this.loading = false;
              this.$router.push({
                path: "/admin/hrm/leave/settings/leave-approval",
              });
            })
            .catch(error => {
              this.loading = false;
              this.$notification.error(error.message);
            });
          return;
        }
      });
    },
    searchEmployees: debounce(function(searchQuery) {
      this.$store
        .dispatch("searchEmployees", searchQuery)
        .then(response => {
          this.employees = response;
        })
        .catch(() => {});
    }, 500),
  },
};
</script>
